import PropTypes from 'prop-types';

import { roundedContainer } from './styles.module.scss';

export const Container = (props) => <div className={roundedContainer}>{props.children}</div>;

Container.propTypes = {
  children: PropTypes.node.isRequired
};
